import { reactive, toRefs, nextTick } from 'vue'
import { mergeDeep } from '@/common/js/utils.js'

import { getTitleLibsByIds, getTargetingLibsByIds, getLandingPageLibsByIds } from '@/api/ptom.data.model'
import { getProjectFormModel, getCreativeFormModel, getPlanFormModel, getConfigFormModel } from '../model/form.js'
import { PLATFORM } from '@/common/js/constants.js'
import { DELIVERY_TYPE } from '../consts/index.js'

export function getTemplateConditionInfo(form) {
  if (!form?.isV3) return form

  const project = { ...form.project }
  delete project.delivery_type
  return { ...form, project }
}

/**
 * @description: 根据id获取模板内定向包、落地页包、文案包最新数据
 * @return {*}
 */
export const getUpdatedLibInfoById = async (form) => {
  const { descriptions, landingPages, targetings, project } = form

  const descriptionsIds = descriptions.map((i) => i.id)
  const landingPagesIds = landingPages.map((i) => i.id)
  const targetingsIds = targetings.map((i) => i.targetingId)

  const res = {
    descriptions: [],
    landingPages: [],
    targetings: []
  }

  try {
    if (descriptionsIds.length) {
      const data = await getTitleLibsByIds({ ids: descriptionsIds })
      res.descriptions = data.map((i) => ({ ...i, content: JSON.parse(i.content) }))
    }

    if (targetingsIds.length) {
      // 应用平台映射为定向受众平台字符串：安卓/IOS/鸿蒙；小程序不传 platform
      const platformStrMap = {
        [PLATFORM.ANDROID]: 'ANDROID',
        [PLATFORM.IOS]: 'IOS',
        [PLATFORM.HARMONY]: 'HARMONY'
      }
      const targetingParams = {
        ids: targetingsIds, platform: platformStrMap[project.ch_platform_id] || 'IOS'
      }
      if (project.ch_platform_id === PLATFORM.MINI_PROGRAM) {
        targetingParams.platform = undefined
      }
      const data = await getTargetingLibsByIds(targetingParams)
      res.targetings = data
    }

    if (landingPagesIds.length) {
      const data = await getLandingPageLibsByIds({ ids: landingPagesIds })
      res.landingPages = data.map((i) => ({ ...i, contents: JSON.parse(i.content) }))
    }

    return res
  } catch (e) { }
}

/**
 * @description: 模板选择
 * @return {*}
 */
export const useTemplateManage = (configForm) => {
  const templateManageModel = reactive({
    selectedTemplateInfo: {},
    onTemplateSelectLoading: false
  })

  async function onTemplateConfirm(row) {
    templateManageModel.onTemplateSelectLoading = true
    const isV3 = configForm.value.isV3

    templateManageModel.selectedTemplateInfo = row

    // 模拟加载
    setTimeout(() => {
      templateManageModel.onTemplateSelectLoading = false
    }, 600)

    try {
      // 先进行一次清空，防止定向包更改参数后，由于v-for使用的key:targetingId没有变化而导致页面不更新
      configForm.value = getConfigFormModel({ isV3 })
      await nextTick()
      const form = JSON.parse(row.conditionInfo)
      const { descriptions, targetings, landingPages } = await getUpdatedLibInfoById(form)
      const mergedForm = mergeDeep(
        {
          project: getProjectFormModel({ isV3 }),
          plan: getPlanFormModel(),
          creatives: []
        },
        form,
        {
          descriptions,
          targetings,
          landingPages
        }
      )
      if (isV3) {
        mergedForm.project.star_task = {}
        mergedForm.project.star_task_list = []
        mergedForm.project.delivery_type = DELIVERY_TYPE.NORMAL
      }

      return {
        ...configForm.value,
        ...mergedForm
      }
    } catch (e) {
      console.log('getUpdatedLibInfoById error output: ', e)
    }
  }

  return {
    ...toRefs(templateManageModel),
    onTemplateConfirm
  }
}
